var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAreaMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5H9V10.5H10.5V7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5H13.5V15H16.5V13.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5V12H9V15H12V13.5H10.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H12V12H21V3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4137 22.4977L8.86425 19.6065L3 20.9918V3H10.5V6H9V4.5H4.5V19.0958L9.13575 18.0007L13.5863 20.8298L17.1135 19.5H19.5V15H18V13.5H21V21H17.3865L13.4137 22.4977Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaMap);
export default __webpack_public_path__ + "static/media/ic-area-map.a725fbd4e0c3b9f9610f6b7463350a1e.svg";
export { ForwardRef as ReactComponent };